import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { MktModal } from '@cps'
import EnUS from './enUS'
import ZhCN from './zhCN'
import DeDE from './deDE'
import './index.scss'

interface IProps {
  resolve: () => void;
  reject?: () => void;
}

const ServiceAgreementModal: FC<IProps> = (props) => {
  const {
    resolve,
    reject
  } = props
  return (
    <MktModal
      className='service-agreement-modal'
      title={i18n.t('mkt.common.service')}
      show
      onClose={reject}
      onSave={resolve}
    >
      {i18n.language === 'zh-CN' ? <ZhCN /> : (i18n.language === 'de-DE' ? <DeDE /> : <EnUS />)}
    </MktModal>
  )
}

export default observer(ServiceAgreementModal)
